import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

/**
 * Diálogo de creación / edición de cliente.
 *
 * - Cuando `editing` es `true`, el título y el texto del botón cambian a
 *   "Editar Cliente" / "Actualizar".
 * - El campo "Días de Crédito" controla SOLO la fecha de vencimiento:
 *   - 0 → vence el mismo día de la factura (cliente de contado)
 *   - >0 → vence N días después
 *   La factura SIEMPRE nace en estado "Pendiente"; para marcarla como pagada
 *   debe registrarse un pago real en Cuentas por Cobrar.
 */
export const ClienteDialog = ({
  open,
  onOpenChange,
  form,
  setForm,
  saving,
  onSave,
  editing = false,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="modal-cliente">
      <DialogHeader>
        <DialogTitle style={{ fontFamily: 'Space Grotesk' }}>
          {editing ? 'Editar Cliente' : 'Nuevo Cliente'}
        </DialogTitle>
        <DialogDescription>
          Los días de crédito definen el plazo de vencimiento. La factura
          siempre se crea pendiente: para marcarla como pagada registra un
          pago en Cuentas por Cobrar.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div>
          <Label htmlFor="cliente-nombre">Nombre *</Label>
          <Input
            id="cliente-nombre"
            placeholder="Nombre del cliente"
            value={form.nombre || ''}
            onChange={(e) => setForm({ ...form, nombre: e.target.value })}
            className="h-11 mt-1.5"
            data-testid="input-cliente-nombre"
          />
        </div>
        <div>
          <Label htmlFor="cliente-tel">Teléfono</Label>
          <Input
            id="cliente-tel"
            placeholder="Teléfono de contacto"
            value={form.telefono || ''}
            onChange={(e) => setForm({ ...form, telefono: e.target.value })}
            className="h-11 mt-1.5"
            data-testid="input-cliente-telefono"
          />
        </div>
        <div>
          <Label htmlFor="cliente-dir">Dirección</Label>
          <Input
            id="cliente-dir"
            placeholder="Dirección del cliente"
            value={form.direccion || ''}
            onChange={(e) => setForm({ ...form, direccion: e.target.value })}
            className="h-11 mt-1.5"
            data-testid="input-cliente-direccion"
          />
        </div>
        <div>
          <Label htmlFor="cliente-credito">Días de Crédito</Label>
          <Input
            id="cliente-credito"
            type="number"
            inputMode="numeric"
            min="0"
            placeholder="0 = Contado (vence el mismo día)"
            value={form.dias_credito ?? 0}
            onChange={(e) => setForm({ ...form, dias_credito: parseInt(e.target.value, 10) || 0 })}
            className="h-11 mt-1.5"
            data-testid="input-dias-credito"
          />
          <p className="text-xs text-muted-foreground mt-1">
            <strong>0 días</strong>: la factura vence el mismo día (cliente de contado).{' '}
            <strong>N días</strong>: vence N días después de la fecha de la factura.{' '}
            <span className="text-amber-700 dark:text-amber-400">
              No marca la factura como pagada automáticamente.
            </span>
          </p>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
        <Button onClick={onSave} disabled={saving} data-testid="btn-guardar-cliente">
          {saving ? 'Guardando...' : (editing ? 'Actualizar Cliente' : 'Guardar Cliente')}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
